import RankTable from './RankTable'

export default RankTable
